import { useQuery } from '@tanstack/react-query';
import type {
  SearchBiomarkersRequestT,
  SearchBiomarkersResponseT,
} from '@lotushealth/lotushealth_js_sdk/schemas';

import { fetchSearchBiomarkers } from '../api/searchBiomarkers.js';
import { labsKeys } from './keys.js';

export function searchBiomarkersQueryDefinition(filters: SearchBiomarkersRequestT) {
  return {
    queryKey: labsKeys.biomarkersSearch(filters),
    queryFn: ({ signal }: { signal?: AbortSignal }) => fetchSearchBiomarkers(filters, signal),
  } as const;
}

export function useSearchBiomarkersQuery(filters: SearchBiomarkersRequestT | undefined) {
  return useQuery({
    queryKey: filters
      ? labsKeys.biomarkersSearch(filters)
      : (['labs', 'biomarkers', 'search', ''] as const),
    queryFn: ({ signal }: { signal?: AbortSignal }): Promise<SearchBiomarkersResponseT> => {
      if (!filters) {
        throw new Error('Missing biomarker search filters');
      }
      return fetchSearchBiomarkers(filters, signal);
    },
    enabled: !!filters,
  });
}
